import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=20d3edee"
import script from "./UserAgreement.vue?vue&type=script&lang=js"
export * from "./UserAgreement.vue?vue&type=script&lang=js"
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=20d3edee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports